<template>
    <div id="ReportPatientAllergies">
      <div v-if="this.filterView">
        <MdTitle v-bind:Text="$t('PatientAllergyRep.RepTitle')" />
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="SearchAllergies"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="SearchAllergies">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
           <MdSelect
              v-bind:Label="$tc('Allergy.PatientStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showPatientIsActiveModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeIsActive"
              v-bind:AllowEmpty="false"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
           <MdSelect
              v-bind:Label="$tc('Allergy.AdmissionStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showIsActiveAdmissionModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeIsActiveAdmission"
              v-bind:AllowEmpty="false"/>
          </b-col> 
          <b-col lg="3" md="3" sm="12">
           <MdSelect
              v-bind:Label="$t('Allergy.AllergyStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeShow"
              v-bind:AllowEmpty="false"/>
          </b-col>                   
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('MdPatientAllergies.Allergies')"
              v-bind:Options="AllergiesList"
              v-bind:Model="AllergiesModel"
              v-bind:FieldDescription="'allergy'"
              v-bind:FieldCode="'allergyCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownAllergies"
              :CustomLabel="customLabelAllergy"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Allergy.Severity')"
              data-field="Additional_EducationStatus"
              v-bind:Options="AllergySeverity"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Model="Allergy.problemSeverity"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownAllergySeverity"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="SearchAllergies"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>
        </b-row>
        
        <div class="row">
          <div class="col-md-12">
            <MdTitle v-bind:Text="$t('Shared.SearchResult')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <div class="row">
              <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    v-bind:IsViewListAllergies="true"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                  </MdTable>
                </div>
            </div>
          </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>   
        
          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>
        </div>
      </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('PatientAllergyRep.RepTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="PatientAllergy"
          :ReportName="'PatientAllergy'"
          :ReportTitle="$t('PatientAllergyRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('PatientAllergyRep.RepTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/PatientAllergies/exportCSV'"
    >    
    </CSVExportHelper>
  </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import PatientService from '@/services/patient.service';
    import Utils from '../../../common/utils'
    import AllergyService from '@/services/allergies.service'
    import AllergyProblemSeveritiesService from '@/services/allergiesproblemseverities.service'
    import DBFunctions from '@/common/DBFunctions.js'
    import { EventBus } from '@/event-bus.js'; 

export default Vue.extend({
    name: "PatientAllergyRep",
    mixins: [ ShowMessage, DBFunctions ],
    components: { DxPopup },
    props: {
      patientCode: String,
      closeWindow: Function,
      recNo: Number,
      patientName: String,
      filterView: Boolean
    },
    data() {
        const alwaysTrue = () => true;
        return {
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false          
            },
            isParamVisible: true,
            isReportVisible: false,
            dateFrom: Utils.formatterDate(Date(), "LLLL"),
            dateTo: Utils.formatterDate(Date(), "LLLL"),
            reportParams: [],
            PatientsList:[],
            AllergiesList:[],
            params: {
              "PatientCodeList": [],
              "AllergyCodeList": [],
              "Show": 'all',
              "IsActive": true,
              "IsActiveAdmission": this.filterView ? alwaysTrue()  : null
            },
            PatientCodeModel:'',
            AllergiesModel: '',
            parameter:{
              Status: true,
              SearchCriteria:'',
              PageNumber : 0,
              PageSize:0,
            },
            AllergySeverity: [],
            Allergy:{            
              problemSeverity: '',
              allergy: ''
            },
            showModel: {
              "value":"all",
              "text":this.$t('Shared.All')
            },
            showOptions: [
              { value: "all", text: this.$t('Shared.All') },
              { value: "true", text:this.$t('Shared.Active') },
              { value: "false", text: this.$t('Shared.Inactive') },
            ],
            showPatientIsActiveModel: {
              "value":"true",
              "text":this.$t('Shared.Active')
            },
            showIsActiveAdmissionModel: {
              "value":"true",
              "text":this.$t('Shared.Active')
            },
          ShowMessageIsEmpty:true,
          ModelCategory:null,
          CategoryOptions:[],       

          fields: [
            { key: 'patientFirstName', sortable: true, label: this.$t('Shared.FirstName'), class: 'text-rigth' }, 
            { key: 'patientLastName', sortable: true, label: this.$t('Shared.LastName'), class: 'text-rigth' },       
            { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
            { key: 'allergy', sortable: true, label: this.$t('Allergy.Allergy'), class: 'text-rigth' },       
            { key: 'isActive', sortable: true, label: this.$t('Shared.Status'), class: 'text-rigth'},       
            { key: 'problem', sortable: true, label: this.$t('AllergiesList.Problem'), class: 'text-rigth' },      
            { key: 'severity', sortable: true, label: this.$t('Allergy.Severity'), class: 'text-rigth' },
            { key: 'patientDOB', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' }
          ],

          pageOptions: [5, 10, 15 ],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          items: [],
          selected: [],
          Header:{},
          refTable: 'selectableTable',
          dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',               
        }
    },
    methods: {

        onShowing(e) {
          let contentElement = e.component.content();
          let titleElement = e.component._$title[0]
          contentElement.style.padding = '0px';
          titleElement.style.padding = '0px 20px'
        },

        onHiddenReport() {
          this.isReportVisible = false
          if(!this.filterView)
            this.closeWindow();
        },

        onClickClose() {
          this.closeWindow()
          this.isParamVisible = false;
        },

        initializeParameters() {
          this.parameter.AllergyCodeList = this.params.AllergyCodeList && this.params.AllergyCodeList !== ''
            ? this.params.AllergyCodeList
            : null;
          this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
              ? this.params.PatientCodeList
              : null;
          this.parameter.PageNumber = this.currentPage;
          this.parameter.PageSize = this.perPage;
          this.parameter.PatientCode = this.patientCode;
          this.parameter.PatientIsActive = (this.params.IsActive === 'all') ? null : this.params.IsActive;
          this.parameter.ActiveAdmission = (this.params.IsActiveAdmission === 'all') ? null : this.params.IsActiveAdmission;
          this.parameter.IsActive = (this.params.Show === 'all') ? null : this.params.Show;
          this.parameter.DateFrom = this.dateFrom;
          this.parameter.DateTo = this.dateTo;
          this.parameter.Severity = this.Allergy.problemSeverity;
        },

        initializePdfParameters() {
          this.reportParams = []
          this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
          this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
          this.reportParams.push({ paramName: 'pPatientCode', paramValue: this.patientCode })
          this.reportParams.push({ paramName: 'pRecNo', paramValue: this.recNo})
          this.reportParams.push({ paramName: 'pSeverity', paramValue: this.Allergy.problemSeverity})
          this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: (this.params.PatientCodeList.length == 0) ? this.patientCode :this.params.PatientCodeList })
          this.reportParams.push({ paramName: 'pAllergyCodeList', paramValue:this.params.AllergyCodeList })
          this.reportParams.push({ paramName: 'pShow', paramValue: this.params.Show})
          this.reportParams.push({ paramName: 'pPatientName', paramValue: this.paramName})
          this.reportParams.push({ paramName: 'pIsActive', paramValue: this.params.IsActive})
          this.reportParams.push({ paramName: 'pIsActiveAdmission', paramValue: this.params.IsActiveAdmission})
          this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
        },

        onClickShowReport() {
          this.initializePdfParameters();
          this.isParamVisible = false
          this.isReportVisible = true
          this.$refs.PatientAllergy.buildDocument(this.reportParams)
        },

        ChangeDropDownPatients(values) {
          this.params.PatientCodeList = [];
          values.forEach(it => {
            this.params.PatientCodeList.push(it.patientcode)
          });
          
          // this.params.PatientCodeList = this.getItemsByComma(values, 'patientcode')
        },

        customLabelPatients ({ patientName, patientcode }) {
          return `${patientName} – ${patientcode}`
        },

        getPatients() {              
          PatientService.getPatientList(this.parameter)
            .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.PatientsList = response.data; 
              this.PatientsList.forEach(function(element) {
                  element.patientName = element.firstname + " " + element.lastname;   
                });
              }      
            })
        },
        reportList() {
            this.checkExistFavorite('/app/reports/patients');
            this.$router.push({ name: "reportListPatient" }).catch(()=>{});
        },
        getItemsByComma(values, field) {
          let len = values.length;
          let valuesSeparated = [];
          if (len > 0){
            var i = 0;
            values.forEach(function(e) {   
              if(i < len-1){
                valuesSeparated += e[field]+",";
              }else{
                valuesSeparated += e[field];
              }
              i++;                    
            });
            return valuesSeparated;
          } else {
            return [];
          }
      },

      getAllergiesProblemSeverities(){
        AllergyProblemSeveritiesService.getAll()
          .then((response) => {
              if(response.status == '200' && response.data){
                this.AllergySeverity = response.data;
              }
          })
      },

      getAllergies() { 
        AllergyService.getAll(this.parameter)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.AllergiesList = response.data;
            }
          })
      },
      ChangeDropDownAllergySeverity(value){
          this.Allergy.problemSeverity = value ? value.description : '';
      },

      ChangeDropDownAllergies(values){
          this.params.AllergyCodeList = this.getItemsByComma(values, 'allergyCode')
      },
      customLabelAllergy ({ allergy }) {
          return `${allergy}`
      },
      ChangeShow(item) {
        this.params.Show = item.value
      },
      async loadContents() {
          await this.getAllergiesProblemSeverities();
          await this.getAllergies();
         
      },
      ChangeIsActive(item) {
        this.params.IsActive = item.value
      },
      ChangeIsActiveAdmission(item) {
        this.params.IsActiveAdmission = item.value
      },
      SearchAllergies(){
        this.Loading = true;
        this.$emit('load', this.Loading);
        this.items = [];
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getTableAllergies();
     
      },
      pageChanged (page) {            
       this.currentPage = page;
       this.getTableAllergies();    
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getTableAllergies();
      },

      onRowSelected(items) {    
      this.selected = items;
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
      ,
      getTableAllergies() {
        this.parameter.PageNumber = this.currentPage;
        this.parameter.PageSize = this.perPage; 
        this.initializeParameters();

        AllergyService.getAll(this.parameter, true)
          .then((response) => {
            this.ShowMessageIsEmpty = false;
            if(response.status == '200' && response.data && response.data.length > 0){
              this.items = response.data;
              this.items.forEach(function(element) {
                  if (element.patientDOB)	
                    element.patientDOB = Utils.formatterDateToString(element.patientDOB); 
                });
              let headerString = response.headers["x-pagination"];
              this.Header = JSON.parse(headerString);
              this.totalRows = this.Header.TotalCount;
            }
            if(this.items.length === 0){
              this.ShowMessageIsEmpty = true;
            }
            this.Loading = false;
            this.$emit('load', this.Loading);
          })
          .catch(error => {
            this.Loading = false;
            this.$emit('load', this.Loading);
            if (!error.response) {
                // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
            } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });
    },
    
    handleCSV(action) {
      this.initializeParameters();
      switch(action) {
        case 'export':
          this.$refs.csvExportHelper.exportCSV(this.parameter);
        break;
        case 'email':
          this.$refs.csvExportHelper.emailCSV(this.parameter);
        break;
        default:
          console.warn('unknow action:', action);
        break;
      }
    },

    handlePdf(action) {
      this.initializePdfParameters();
      switch(action) {
        case 'export':
          this.$refs.csvExportHelper.exportToPdf('PatientAllergy', true, false, this.reportParams);
        break;
        case 'email':
          this.$refs.csvExportHelper.emailPdf('PatientAllergy', true, false, this.reportParams);
        break;
        default:
          console.warn('unknow action:', action);
        break;
      }
    },
  },

  created() {
    
  },
  mounted () {
    
    if(!this.filterView) {
        this.onClickShowReport();
    } else {
      this.getPatients(); 
      this.loadContents()
      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
    }

    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
  },
})
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
